'use client';

import { parseUserAgent } from '@diritto/common/utils/userAgent';
import { useInAppState } from '@/contexts/InAppProvider';
import { PublisherOpenPage } from 'app/(appHeader)/events/publisher-open/PublisherOpenPage';
import { eventsDescription } from 'constants/metadata';

export default function Page() {
  const { userAgent } = useInAppState();
  const { isApp } = parseUserAgent(userAgent ?? '');

  return (
    <>
      <title>디리토 이제 출간도 해요! | 디리토</title>
      <meta name="description" content={eventsDescription} />
      <PublisherOpenPage isApp={isApp} />
    </>
  );
}
